export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-[#444c42]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Get in Touch
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Ready to transform your smile? Contact us today to schedule your free consultation.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">Visit Us</h3>
                  <p className="text-base text-white/90">
                    1 Centenary Way<br />
                    Beaulieu Square, Springfield<br />
                    Chelmsford CM1 6AU
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">Call Us</h3>
                  <a
                    href="tel:01245465586"
                    className="text-base text-white/90 hover:text-[#D0A24F] transition-colors cursor-pointer"
                  >
                    01245 465586
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">Email Us</h3>
                  <a
                    href="mailto:info@beaulieudental.co.uk"
                    className="text-base text-white/90 hover:text-[#D0A24F] transition-colors cursor-pointer"
                  >
                    info@beaulieudental.co.uk
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D0A24F] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-fill text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">Over 270 5 Star Reviews</h3>
                  <a
                    href="https://www.google.com/maps/place/Beaulieu+Dental/@51.7598302,0.4994672,17z/data=!4m16!1m9!3m8!1s0x47d8e9361f3a520f:0xff99227fe78d18b4!2sBeaulieu+Dental!8m2!3d51.7598302!4d0.4994672!9m1!1b1!16s%2Fg%2F11gfctc96j!3m5!1s0x47d8e9361f3a520f:0xff99227fe78d18b4!8m2!3d51.7598302!4d0.4994672!16s%2Fg%2F11gfctc96j?entry=ttu&g_ep=EgoyMDI1MTIwMi4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-base text-white/90 hover:text-[#D0A24F] transition-colors cursor-pointer inline-flex items-center gap-2"
                  >
                    Read our Google Reviews
                    <i className="ri-external-link-line"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Main Website Link */}
            <div className="bg-gradient-to-br from-[#D0A24F] to-[#F5d383] p-8 rounded-2xl shadow-xl">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-home-smile-line text-2xl text-[#D0A24F]"></i>
                </div>
                <h3 className="text-2xl font-bold text-white">Explore Our Full Range of Services</h3>
              </div>
              <p className="text-base text-white/90 mb-6">
                Discover all our dental treatments, meet our team, and learn more about Beaulieu Dental.
              </p>
              <a
                href="https://beaulieudental.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white text-[#444c42] px-6 py-3 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all cursor-pointer"
              >
                Visit Our Main Website
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Google Map */}
          <div className="h-[600px] rounded-2xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2459.8234567890123!2d0.4994672!3d51.7598302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8e9361f3a520f%3A0xff99227fe78d18b4!2sBeaulieu%20Dental!5e0!3m2!1sen!2suk!4v1234567890123!5m2!1sen!2suk"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Beaulieu Dental Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
